<template>
  <section class="page-content">
    <main>
      <Divider class="p-divider-horizontal mt-0" v-if="!autoUpdate" />
      <div class="filter-card">
        <div class="grid">
          <div class="col-12 md:col-7">
            <div class="p-inputgroup" style="overflow: hidden;">
              <span class="p-inputgroup-addon">
                <i class="pi pi-filter-fill"></i>
              </span>
              <Dropdown class="select-filter-type" v-model="selectedFilter" :options="customFilters" optionLabel="name"
                @change="onFilterElementChange" placeholder="Select filter" appendTo="body" />
            </div>
          </div>

          <div class="col-12 md:col-5">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-eye"></i>
              </span>
              <Dropdown v-model="selectedFilterType" :options="customFilterTypes" optionLabel="name"
                placeholder="Select filter type" :disabled="!selectedFilter" appendTo="body" />
            </div>
          </div>
        </div>

        <div v-if="selectedFilterType">
          <div class="grid" v-if="selectedFilterType.code === 'select'">
            <div class="col-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <MultiSelect v-if="selectedFilter.code === 'carrier'" v-model="selectedCarriers" :options="customCarriers"
                  :optionLabel="'official_name'" placeholder="Select carriers" display="chip" :filter="true"
                  appendTo="body" class="multi-select">
                </MultiSelect>
                <MultiSelect v-if="selectedFilter.code === 'shipment_status'" v-model="selectedMilestones"
                  :options="customMilestones" :optionLabel="'description'" placeholder="Select milestones" display="chip"
                  :filter="true" appendTo="body" class="multi-select">
                </MultiSelect>
              </div>
            </div>
          </div>

          <div class="grid" v-if="selectedFilterType.code === 'code'">
            <div class="col-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <InputText class="p-inputtext-lg" id="code" type="text" v-model="code"
                  @input="(val) => (code = code.toUpperCase())" :placeholder="selectedFilter.name + ' Country'" />
              </div>
            </div>
          </div>

          <div class="grid" v-if="selectedFilterType.code === 'daterange'">
            <div class="col-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-calendar"></i>
                </span>
                <Calendar v-model="dateRange" id="calendar" dateFormat="yy/mm/dd" selectionMode="range"
                  :manualInput="false" ref="dateSelect" @date-select="hideOnDateSelection(dateRange)" appendTo="body" />
              </div>
            </div>
          </div>

          <div class="grid range-container"
            v-if="selectedFilterType.code === 'dayrange' || selectedFilterType.code === 'numberrange'">
            <div class="col-12 md:col-6">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <InputNumber v-model="dayMin" id="dayMin" :max="500" showButtons />
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <InputNumber v-model="dayMax" id="dayMax" :max="500" showButtons />
              </div>
            </div>
          </div>

          <div class="grid button-container" v-if="selectedFilterType.code === 'question'">
            <div class="col-12 md:col-6">
              <Button label="Yes" class="btn-question p-button-raised p-ripple" @click="nullQuestion(false)" v-ripple />
            </div>
            <div class="col-12 md:col-6">
              <Button label="No" class="btn-question p-button-raised p-button-secondary p-ripple"
                @click="nullQuestion(true)" v-ripple />
            </div>
          </div>
        </div>
        <div class="btn-section">
          <Button label="Clear Filters" class="p-button-raised p-button-secondary" icon="pi pi-refresh" iconPos="left"
            style="float:right;margin-right:6px" @click="clearFilters" />
          <Button label="Apply Filters" class="p-button-raised" icon="pi pi-refresh" iconPos="left"
            style="float:right;margin-right:6px" @click="applyFilters" v-if="!autoUpdate && tags.length > 0" />
          <Button label="Add Filter" class="p-button-raised" icon="pi pi-sync" iconPos="left"
            style="float:right;margin-right:6px" @click="addFilter" />
        </div>
        <div v-if="tags.length > 0 && !autoUpdate" class="filter-section">
          <Divider class="filter-list" align="center">
            <div class="inline-flex align-items-center">
              <i class="pi pi-filter-fill mr-2"></i>
              <b>Current filter list</b>
            </div>
          </Divider>
          <div v-for="(tag, index) in tags" :key="index" class="tags-container">
            <div class="tags-special">
              <Chip class="tag-special black">{{ tag.name }}</Chip>
              <Chip class="tag-special grey">{{ tag.type }}</Chip>
              <Chip class="tag-special green">{{ tag.value }}</Chip>
              <span class="close-icon" @click="removeFilter(tag, index)">&times;</span>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
  
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mapFilterTypes } from '@/models/filters/FilterTypes'
import Ripple from 'primevue/ripple'

export default {
  name: 'custom-filters',
  props: ['customFilters', 'previousFilters', 'previousTags', 'automatic'],
  created () {
    this.initializeFilterTypes()
  },
  directives: {
    ripple: Ripple
  },
  mounted () {
    this.$emit('loading')
    const promises = [
      this.getCarriers().then(response => {
        this.customCarriers = this.initializeCarriers(response) || []
        this.getMilestones().then(response => {
          this.customMilestones = response
          this.selectedFilters = this.previousFilters || []
          this.tags = this.previousTags || []
          this.autoUpdate = this.automatic || false
          if (this.selectedFilters.carrier) {
            this.selectedCarriers = this.customCarriers.filter(carrier => {
              const selectedCarrierIds = this.selectedFilters.carrier.map(id => id.toString())
              return selectedCarrierIds.includes(carrier.id.toString())
            })
          }
          if (this.selectedFilters.shipment_status) {
            this.selectedMilestones = this.customMilestones.filter(milestone => {
              const selectedMilestonesIds = this.selectedFilters.shipment_status.map(id => id.toString())
              return selectedMilestonesIds.includes(milestone.id.toString())
            })
          }
        })
      })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      filterTypes: {},
      selectedFilters: [],
      customCarriers: [],
      customMilestones: [],
      customFilterTypes: [],
      dateRange: [],
      tags: [],
      selectedCarriers: [],
      selectedMilestones: [],
      selectedFilter: '',
      selectedFilterType: '',
      code: '',
      carrier: null,
      dayMin: null,
      dayMax: null,
      autoUpdate: false,
      isNull: null
    }
  },
  methods: {
    ...mapActions({
      getCarriers: 'carrier/list',
      getMilestones: 'milestone/list'
    }),

    /**
     ** Initializes the filter types by mapping them using the 'mapFilterTypes' function.
     * @returns {void}
     */
    initializeFilterTypes () {
      this.filterTypes = mapFilterTypes()
    },

    /**
     ** Initializes the list of carriers by extracting required fields from the provided carrier objects.
     * @param {Array} carriers - The array of carrier objects.
     * @returns {Array} - The array of carrier objects containing only 'id' and 'official_name' fields.
     */
    initializeCarriers (carriers) {
      return carriers.map(carrier => {
        const { id, official_name } = carrier
        return { id, official_name }
      })
    },

    /**
     ** Adds a filter to the list of selected filters based on the current selected filter and input values.
     * @returns {void}
     */
    addFilter () {
      if (this.selectedFilterType && this.selectedFilterType.code &&
        ((this.selectedFilter.code === 'carrier' && this.selectedCarriers.length > 0) ||
          (this.selectedFilter.code === 'shipment_status' && this.selectedMilestones.length > 0) ||
          this.isNull !== null || this.code || this.dayMin || this.dayMax || this.dateRange.length > 0)) {
        const dateRange = this.formatDateRange(this.dateRange)

        const key = this.selectedFilter.code
        const params = this.selectedFilterType.params
        const codeParams = params.length > 0 ? params.map(param => key + '_' + param) : [key]

        this.addTag(dateRange, codeParams)

        if (codeParams.length < 2) {
          if (codeParams[0] === 'carrier') {
            this.selectedFilters[codeParams[0]] = this.selectedCarriers.map(carrier => carrier.id)
          } else if (codeParams[0] === 'shipment_status') {
            this.selectedFilters[codeParams[0]] = this.selectedMilestones.map(milestone => milestone.id)
          } else if (codeParams[0].includes('isnull')) this.selectedFilters[codeParams[0]] = this.isNull
          else this.selectedFilters[codeParams[0]] = this.code
        } else {
          if (codeParams[0].includes('after')) {
            this.selectedFilters[codeParams[0]] = dateRange[0]
            this.selectedFilters[codeParams[1]] = dateRange[1]
          } else {
            this.selectedFilters[codeParams[0]] = this.dayMin
            this.selectedFilters[codeParams[1]] = this.dayMax
          }
        }

        if (this.autoUpdate) this.applyFilters()
        this.resetFields()
      }
    },

    /**
     ** Adds a tag to the list of selected tags. If a tag with the same key already exists, it replaces it with the new one.
     * @param {Array<Date>} dateRange - An array containing one or two Date objects representing the date range.
     * @param {Array<string>} codeParams - An array containing all params of filter type object.
     */
    addTag (dateRange, codeParams) {
      let value = ''

      if (this.selectedFilter.code === 'carrier' && this.selectedCarriers.length > 0) {
        this.tags = this.tags.filter(obj => !(obj.name === this.selectedFilter.name && obj.type === this.selectedFilterType.name))

        this.selectedCarriers.forEach(selectedCarrier => {
          const tag = this.createTag(codeParams, selectedCarrier.official_name, selectedCarrier.id)
          this.tags.push(tag)
        })
      } else if (this.selectedFilter.code === 'shipment_status' && this.selectedMilestones.length > 0) {
        this.tags = this.tags.filter(obj => !(obj.name === this.selectedFilter.name && obj.type === this.selectedFilterType.name))

        this.selectedMilestones.forEach(selectedMilestone => {
          const tag = this.createTag(codeParams, selectedMilestone.description, selectedMilestone.id)
          this.tags.push(tag)
        })
      } else {
        if (this.isNull != null) value = this.isNull ? 'No' : 'Yes'
        else if (this.code) value = this.code
        else if (dateRange && dateRange.length > 0) {
          const [dateBefore, dateAfter] = dateRange.map(date => date || '---')
          value = `${dateBefore} To ${dateAfter}`
        } else if (this.dayMin || this.dayMax) {
          const [relMin, relMax] = [this.dayMin || '---', this.dayMax || '---']
          value = `${relMin} To ${relMax}`
        }

        const tag = this.createTag(codeParams, value)
        this.tags = this.tags.filter(obj => !(obj.name === tag.name && obj.type === tag.type))
        this.tags.push(tag)
      }
    },

    /**
     ** Return object tag
     * @param {Array<string>} codeParams - An array containing all params of filter type object.
     * @param {string} value - The value of selected tag.
     */
    createTag (codeParams, value, id) {
      return {
        name: this.selectedFilter.name,
        type: this.selectedFilterType.name,
        code: codeParams,
        value: value,
        id: id
      }
    },

    /**
     ** Removes a filter tag from the selected filters and updates the filter state.
     * @param {Object} tag - The filter tag object to be removed.
     * @param {number} index - The index of the tag in the tags array.
     */
    removeFilter (tag, index) {
      if (tag.code[0] === 'carrier') this.selectedFilters.carrier = this.selectedFilters.carrier.filter(id => id !== String(tag.id))
      else if (tag.code[0] === 'shipment_status') this.selectedFilters.shipment_status = this.selectedFilters.shipment_status.filter(id => id !== String(tag.id))
      else this.selectedFilters[tag.code[0]] = null
      if (tag.code[1]) this.selectedFilters[tag.code[1]] = null
      this.tags.splice(index, 1)

      if (this.autoUpdate) this.applyFilters()
    },

    /**
     ** Applies the selected filters by emitting an 'apply' event with the selected filters as payload.
     * @returns {void}
     */
    applyFilters () {
      this.$emit('apply', { filters: this.selectedFilters, tags: this.tags })
      if (this.autoUpdate) this.close()
    },

    /**
     ** Clears all selected filters and tags by resetting filter properties to default values.
     * @returns {void}
     */
    clearFilters () {
      this.selectedFilters = []
      this.selectedCarriers = []
      this.selectedMilestones = []
      this.tags = []
      this.resetFields()
      this.$emit('apply', { filters: this.selectedFilters, tags: this.tags })
    },

    /**
     ** Close custom filters modal.
     * @returns {void}
     */
    close () {
      this.$emit('close')
    },

    /**
     ** Hides the date selection overlay when a date range is selected.
     *  @param {Array<Date>} value - An array containing the selected date range.
     */
    hideOnDateSelection (value) {
      // Get a reference to the date selection calendar component
      const calendar = this.$refs.dateSelect || null
      // Hide the overlay if the calendar exists and the end date is selected
      if (calendar && value[1] !== null) calendar.overlayVisible = false
    },

    /**
     ** Formats a date range provided as an array of Date objects.
     * @param {Array<Date>} dateRange - The array containing the date range to be formatted.
     * @returns {Array<string>} - An array of formatted date strings.
     */
    formatDateRange (dateRange) {
      if (Array.isArray(dateRange)) {
        if (dateRange.length === 2) {
          // Format each date in the array if it exists
          return dateRange.map(date => {
            return date ? date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) : null
          })
        } else if (dateRange.length === 1) {
          // Format the single date in the array if it exists
          const date = dateRange[0]
          return date ? date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) : null
        }
      }
      return dateRange
    },

    /**
     ** Clears all filters by resetting filter properties to default values.
     * @returns {void}
     */
    resetFields () {
      this.selectedFilter = ''
      this.selectedFilterType = ''
      this.code = ''
      this.dateRange = []
      this.carrier = null
      this.dayMin = null
      this.dayMax = null
      this.isNull = null
    },

    /**
     ** Show filter types depending of filter selected.
     * @returns {void}
     */
    onFilterElementChange () {
      this.customFilterTypes = this.selectedFilter ? this.selectedFilter.types.map(type => this.filterTypes[type]) : []
      this.selectedFilterType = this.customFilterTypes[0]
      if (this.selectedFilterType.code === 'code') setTimeout(() => { document.getElementById('code').focus() }, 100)
    },

    /**
     ** Changes the state of the isNull variable based on the provided value.
     * @param {boolean} value - The new value for the isNull variable.
     */
    nullQuestion (value) {
      this.isNull = value
    }
  },
  computed: {
    ...mapState({
      count: state => state.shipment.count,
      pageSize: state => state.pageSize
    }),
    ...mapGetters({ hasPermission: 'hasPermission' }),
    columns () {
      var selectedHeaders = this.selectedHeaders.filter((x) => this.tableHeaders.indexOf(x) >= 0)
      let columns = this.fixedHeaders.concat(selectedHeaders)
      if (selectedHeaders.length === 0) {
        columns = columns.concat(this.tableHeaders)
      }
      return [...new Set(columns)]
    }
  }
}
</script>
<style lang="scss">
.filter-card {
  width: 99%;
}

.btn-section {
  padding: 5px 0;
}

.filter-list {
  margin: 3rem 0px 10px 0px !important;
}

.filter-list .p-divider-content {
  background-color: #F5F7FA !important;
}

.tags-container {
  padding: 10px;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;

  &:last-child {
    border-bottom: 1px solid #ccc;
  }
}

.tags-special {
  align-items: center;
  gap: 3px;
}

.tag-special {
  border-radius: 5px !important;
  color: #fff !important;

  &.black {
    background-color: black;
  }

  &.grey {
    background-color: grey;
  }

  &.green {
    background-color: #009c95;
  }
}

.close-icon {
  float: right;
  margin-right: 5px;
  font-weight: bold;
  background-color: grey;
  padding: 1px 6px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
}

.grid {
  margin-right: 0;

  &.range-container {
    gap: 14px;
  }

  &.button-container {
    margin: 0 0px 0 -6px;
    gap: 14px;

    .btn-question {
      width: 100%;
      font-size: 20px;
      box-shadow: 3px 2px 10px 1px rgba(0, 0, 0, 0.5) !important;

      .p-ink {
        background: rgba(#000000, 0.3);
      }

      &:focus {
        background-color: #006a65;
        transform: scale(0.95);
      }

      &.p-button-secondary:focus {
        background-color: #5a6268 !important;
      }
    }
  }
}

.p-dropdown {
  width: unset !important;
}

input {
  border: 1px solid #ced4da !important;
}

.p-multiselect .p-multiselect-label {
  display: flex;
  flex-wrap: wrap;
}

.p-multiselect .p-multiselect-token {
  margin-bottom: .5rem
}

.p-divider-solid.p-divider-horizontal:before {
  border-top-style: solid !important;
}

.p-divider-solid.p-divider-horizontal:before {
  border-top-style: solid !important;
}

@media screen and (max-width: 1600px) {
  .grid {
    display: block;
  }

  .col-12 {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomFilters.vue